import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    ActivityRecordType,
} from 'app/enums/label.enums'
import {
    ActivityRecord,
} from '../activityRecords.types'

import {
    allowedDurationValues,
} from './utils'

type Fields = keyof ActivityRecord

const getParticipantsLabel = ({
    contactName,
}) => {
    return contactName
}

const getTitle = ({
    disabled,
    exists,
    l,
}: {
    disabled?: boolean,
    exists?: boolean
    l: (key: string) => string,
}) => {
    if (disabled) return l('ACTIVITY_RECORD_DETAILS')
    if (exists) return l('UPDATE_ACTIVITY_RECORD_DETAILS')
    return l('NEW_ACTIVITY_RECORD')
}

const getFields = ({
    getAllowedValues,
    exists,
    organizerName,
    companies,
    participantsTypes,
    disabled,
    l,
}: {
    getAllowedValues: (v: Record<string, any>) => Record<string, any>,
    exists: boolean
    organizerName?: string,
    companies?: number[],
    participantsTypes: string[],
    disabled?: boolean,
    l: (key: string) => string,
}): DTOCardFormField<Fields>[] => {
    return [
        {
            title: getTitle({
                exists, disabled, l,
            }),
            className: 'general',
            fields: [
                {
                    name: 'type',
                    labelKey: 'TYPE',
                    componentName: 'EnumSelector',
                    required: true,
                    useDropdown: false,
                    allowedValues: getAllowedValues(ActivityRecordType),
                    className: 'type',
                    noSort: true,
                },
                {
                    name: 'subject',
                    labelKey: 'SUBJECT',
                    componentName: 'InputSingleline',
                    required: true,
                },
                {
                    name: 'happenedOn',
                    labelKey: 'HAPPENED_ON',
                    componentName: 'DateTimeZonedSelect',
                    required: true,
                },
                {
                    name: 'supportingDocuments',
                    labelKey: 'SUPPORTING_DOCUMENTS',
                    componentName: 'AttachmentsObjectSelector',
                    className: 'attachments',
                },
                {
                    name: 'companies',
                    labelKey: 'COMPANY',
                    componentName: 'MultipleCompaniesSelector',
                    required: true,
                    className: 'company',
                },
                {
                    name: 'durationInMinutes',
                    labelKey: 'DURATION',
                    componentName: 'EnumSelector',
                    allowedValues: allowedDurationValues,
                    noSort: true,
                },
                {
                    name: 'participants',
                    labelKey: 'PARTICIPANTS',
                    componentName: 'MultipleContactObjectSelector',
                    required: true,
                    disabled: disabled || !companies,
                    includeFilters: {
                        isProspect: [
                            true,
                            false,
                        ],
                    },
                    filters: {
                        companyAndTypeFilter: {
                            skycellCompany: true,
                            companyId: companies,
                            type: participantsTypes,
                        },
                    },
                    getValueLabel: getParticipantsLabel,
                    className: 'participants',
                    disableCache: true,
                },
                {
                    name: 'organizer',
                    labelKey: 'ORGANIZER',
                    componentName: exists ? 'UserObjectSelector' : 'InputSingleline',
                    value: exists ? undefined : organizerName,
                    disabled: true,
                },
                {
                    name: 'changedOn',
                    labelKey: 'LAST_UPDATED',
                    componentName: 'DateTimeSelect',
                    disabled: exists,
                    hidden: !exists,
                    className: 'changedOn',
                },
                {
                    name: 'isFollowUpNeeded',
                    componentName: 'Checkbox',
                    className: 'followUpNeeded',
                    labelKey: 'FOLLOW_UP_NEEDED',
                },
                {
                    name: 'notifiedUsers',
                    componentName: 'MultipleUserSelector',
                    labelKey: 'NOTIFY_USERS',
                    className: 'notifiedUsers',
                },
            ],
        },
        {
            title: l('DETAILS'),
            className: 'details',
            fields: [
                {
                    name: 'agenda',
                    labelKey: 'AGENDA',
                    componentName: 'LongText',
                    required: true,
                    rows: 10,
                },
                {
                    name: 'outcomes',
                    labelKey: 'OUTCOMES',
                    componentName: 'LongText',
                    required: true,
                    rows: 10,
                },
            ],
        },
    ]
}

export default getFields
